<template>
    <v-card flat v-if="hasAnItem || work?.graph?.img">
        <v-card-title class="px-0"> 작품가격 비교자료 </v-card-title>
        <v-img :src="work?.graph?.img?.url" />
        <template v-if="hasAnItem">
            <v-btn-toggle v-model="key" v-if="1 < keys.length" class="lang-toggle mt-20">
                <template v-for="value in keys">
                    <v-btn v-bind="{ value }" :key="value"> {{ getKeyText(value) }}</v-btn>
                </template>
            </v-btn-toggle>
            <v-card-text> {{ work?.graph?.[key] || "" }}</v-card-text>
        </template>
    </v-card>
</template>

<script>
export default {
    props: {
        work: { type: Object, default: () => ({}) },
    },
    data: () => ({
        key: "ko",
        show: false,
    }),
    computed: {
        keys() {
            return ["ko", "en"].filter((key) => !!this.work?.graph?.[key]);
        },
        hasAnItem() {
            return !!this.keys.length;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        keys() {
            this.init();
        },
    },
    methods: {
        init() {
            this.key = this.keys?.[0] || "ko";
        },
        onReady() {
            this.show = true;
        },
        getKeyText(key) {
            switch (key) {
                case "ko": {
                    return "Korean";
                }
                case "en": {
                    return "English";
                }
            }
        },
    },
};
</script>

<style scoped>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
    border-color: #181818 !important;
}
</style>
